// assets/manual-pdf.js
class ManualPdf extends HTMLElement {
  constructor() {
    super();

    this.PRINT_DELAY = 500;

    this.addEventListeners();
  }

  addEventListeners() {
    this.button.addEventListener("click", () => this.handleButtonClick());
  }

  async handleButtonClick() {
    const images = this.manualContent.querySelectorAll("[data-media-img]");

    images.forEach(image => image.removeAttribute("loading"));

    setTimeout(() => window.print(), this.PRINT_DELAY);
  }

  get button() {
    return this.querySelector("[data-pdf-download]");
  }

  get manualContent() {
    return document.querySelector("[data-manual-content]");
  }
}

if (!customElements.get('manual-pdf')) {
  customElements.define('manual-pdf', ManualPdf);
}